import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function VirginMuskmelonMojito() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Virgin Muskmelon Mojito</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 8 }}>Non-alcoholic — sweet muskmelon, lime, and mint with fizz.</p>
          <p style={{ fontSize: "1rem", color: "#666", marginBottom: 16 }}>Virgin (no rum or spirits).</p>
          <span className="season-badge season-summer">☀️ Best in Summer</span>
          <ImageWithFallback src="/virgin_muskmelon_mojito.png" alt="Tall glass of orange pulpy virgin muskmelon mojito with lime and a straw" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 20px 0",
          maxWidth: 1200,
          margin: "0 auto",
          flexWrap: "wrap"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>2 cups ripe muskmelon (kharbuja), cubed</li>
              <li>8–10 fresh mint leaves, plus extra for garnish</li>
              <li>1 lime — half juiced, half cut into wedges</li>
              <li>1–2 tbsp simple syrup or sugar (to taste)</li>
              <li>1 cup chilled soda water or sparkling water</li>
              <li>Ice cubes</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Blend muskmelon cubes with lime juice until smooth. For a thinner drink, strain; for a thick, pulpy mojito like the photo, skip straining.</li>
              <li>In a tall glass, gently muddle mint leaves with simple syrup or sugar and a lime wedge.</li>
              <li>Fill the glass with ice, pour in the muskmelon purée, and top with soda water. Stir lightly.</li>
              <li>Garnish with mint and a lime wedge. Serve cold — completely virgin, no alcohol.</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Pick a muskmelon that smells sweet at the stem end — that's the best sign of ripeness.</li>
              <li>Chill the muskmelon before blending so the drink stays cold without watering down on ice.</li>
              <li>Muddle the mint lightly; bruising it too hard makes the drink taste grassy.</li>
              <li>Pour the soda water down the side of the glass to keep the fizz from going flat.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Muskmelon is over 90% water, making this a great way to stay hydrated in the summer heat.</li>
              <li>Rich in vitamin A and C, which support skin and immune health.</li>
              <li>Lime adds antioxidants and helps freshen digestion.</li>
              <li>Alcohol-free and naturally sweetened, so it's easy on everyone in the family.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default VirginMuskmelonMojito;
